import {animate, state, style, transition, trigger} from '@angular/animations';

export enum CardState {
  Open = 'open',
  Closed = 'closed',
}

export const listExpand = trigger('listExpand', [
  state('open', style({
    opacity: 1,
    height: "*",
    overflow: 'hidden',
  })),

  state('closed', style({
    opacity: 0,
    height: 0,
    overflow: 'hidden',
  })),
  transition('open => closed', animate('200ms ease-out')),
  transition('closed => open', animate('200ms ease-in')),
])

export const revealExpand = trigger('revealExpand', [
  state('open', style({
    opacity: 1,
    height: "*",
    overflow: 'hidden',

  })),

  state('closed', style({
    opacity: 0,
    height: 0,
    overflow: 'hidden',

  })),
  transition('open => closed', animate('200ms ease-out')),
  transition('closed => open', animate('200ms ease-in')),
])

export const listTransition = trigger('listTransition', [
  state('start', style({
    opacity: 0.7,

  })),

  state('stop', style({
    opacity: 1,
  })),
  transition('start => stop', animate('50ms')),
  transition('stop => start', animate('50ms')),
])

export const answersExpand = trigger('answersExpand', [

  state('open', style({
    opacity: 1,
    height: "*",
    overflow: 'hidden',
  })),

  state('closed', style({
    opacity: 0,
    height: 0,
    overflow: 'hidden',
  })),
  transition('open => closed', animate('200ms ease-out')),
  transition('closed => open', animate('200ms ease-in')),
])

export const rotateArrow = trigger('rotateArrow', [
  state('open', style({
    transform: "rotate(90deg)",

  })),

  state('closed', style({
    transform: "rotate(0deg)",

  })),
  transition('open => closed', animate('200ms ease-out')),
  transition('closed => open', animate('200ms ease-in')),
])

export const cardOpen = trigger('cardOpen', [
  state('open', style({
    overflow: 'hidden',
    height: '*'
  })),
  state('closed', style({
    overflow: 'hidden',
    height: '0',
    padding: '0',
  })),
  transition('open => closed', animate('400ms ease-out')),
  transition('closed => open', animate('400ms ease-in')),
]);

export const openHorizontal = trigger('openHorizontal', [
  state('open', style({
    overflow: 'hidden',
    width: '*'
  })),
  state('closed', style({
    overflow: 'hidden',
    width: '0',
    padding: '0'

  })),
  transition('open => closed', animate('400ms ease-out')),
  transition('closed => open', animate('400ms ease-in')),
]);

export const openHorizontalSimple = trigger('openHorizontalSimple', [
  state('open', style({

    width: '*'
  })),
  state('closed', style({
    overflow: 'hidden',
    width: '0',
    padding: '0'

  })),
  transition('open => closed', animate('300ms ease-out')),
  transition('closed => open', animate('300ms ease-in')),
]);

export const openHorizontalQuick = trigger('openHorizontalQuick', [
  state('open', style({
    overflow: 'hidden',
    width: '*'
  })),
  state('closed', style({
    overflow: 'hidden',
    width: '0',
    padding: '0'
  })),
  transition('open => closed', animate('200ms ease-out')),
  transition('closed => open', animate('200ms ease-in')),
]);

export const showHide = trigger('showHide', [
  state('open', style({
    opacity: 1,
    visibility: 'visible',
  })),
  state('closed', style({
    visibility: 'hidden',
    opacity: 0,
  })),
  transition('open => closed', animate('200ms ease-out')),
  transition('closed => open', animate('200ms ease-in')),
]);
